import { createApp } from 'vue';
import { createPinia } from 'pinia';
import * as Sentry from '@sentry/vue';
import App from './App.vue';
import router from './router/Router';

import CorporationVueLibrary from 'corporation-vue-library';
import 'corporation-vue-library/dist/style.css';

import 'bootstrap-vue-next/dist/bootstrap-vue-next.css';
import 'bootstrap/dist/css/bootstrap.css';
import BootstrapVueNext from 'bootstrap-vue-next';

import 'vue-toast-notification/dist/theme-sugar.css';
import ToastPlugin from 'vue-toast-notification';

import BaseApiUrl from '@services/BaseApiUrl';
import { takeForbiddenMessage } from '@services/AxiosInstance';

import i18n from './helpers/lang/i18n';
import { loadLocaleMessages } from './helpers/lang/loadLocale';

const locale = 'es_ar';
const messages = loadLocaleMessages(locale);
i18n.global.setLocaleMessage(locale, messages);
i18n.global.locale.value = locale;

const pinia = createPinia();

const app = createApp(App)
  .use(i18n)
  .use(pinia)
  .use(router)
  .use(CorporationVueLibrary)
  .use(BootstrapVueNext)
  .use(ToastPlugin);

const toast = app.config.globalProperties.$toast;
const showErrorToast = toast.error.bind(toast);
toast.error = (message: string, options?: object) => showErrorToast(takeForbiddenMessage() ?? message, options);

Sentry.init({
  app,
  dsn: import.meta.env.VITE_SENTRY_DSN,
  environment: import.meta.env.VITE_SENTRY_ENVIRONMENT || 'local',
  enabled: !!import.meta.env.VITE_SENTRY_DSN && import.meta.env.VITE_SENTRY_ENVIRONMENT !== 'local',
  sendDefaultPii: true,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration({
      maskAllText: false,
      blockAllMedia: false,
      networkDetailAllowUrls: [/api\/.*/],
    }),
    Sentry.feedbackIntegration({
      autoInject: false,
    }),
  ],
  tracePropagationTargets: [
    'localhost',
    /^https:\/\/tryger\.leverbox\.com\.ar/,
    /api\/.*/,
  ],
  tracesSampleRate: import.meta.env.VITE_SENTRY_ENVIRONMENT === 'production' ? 0.2 : 1.0,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
});

app.config.globalProperties.$api = BaseApiUrl;

app.mount('#app');
